import {
  CButton,
  CCol,
  CDatePicker,
  CForm,
  CFormFeedback,
  CFormInput,
  CFormLabel,
  CLoadingButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from '@coreui/react-pro'
import moment from 'moment'
import React, { useState } from 'react'
import PlayerAvailabilityService from 'src/service/PlayerAvailabilityService'
import ToastComponent from 'src/components/common/TaostComponent'

const SetAvailabilityModal = ({ visible, onClose, playerIds, onSuccess }) => {
  const [dateFrom, setDateFrom] = useState('')
  const [dateTill, setDateTill] = useState('')
  const [reason, setReason] = useState('')
  const [touched, setTouched] = useState(false)
  const [loader, setLoader] = useState(false)

  const resetForm = () => {
    setDateFrom('')
    setDateTill('')
    setReason('')
    setTouched(false)
  }

  const handleClose = () => {
    resetForm()
    onClose()
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setTouched(true)
    if (!dateFrom || !dateTill) return
    setLoader(true)
    PlayerAvailabilityService.saveAvailability({
      player: playerIds,
      date_from: dateFrom,
      date_till: dateTill,
      reason,
    })
      .then((res) => {
        if (res.status === 200) {
          ToastComponent(res.message, 'success')
          onSuccess()
          handleClose()
        } else {
          ToastComponent(res.message, 'error')
        }
        setLoader(false)
      })
      .catch(() => {
        ToastComponent('Something went wrong', 'error')
        setLoader(false)
      })
  }

  return (
    <CModal visible={visible} onClose={handleClose}>
      <CForm onSubmit={handleSubmit}>
        <CModalHeader>
          <CModalTitle>Set Player Availability</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <div className="text-medium-emphasis mb-3">
            Update availability for {playerIds.length} selected player
            {playerIds.length !== 1 ? 's' : ''}.
          </div>
          <CRow className="g-3">
            <CCol md={6}>
              <CFormLabel htmlFor="unavailable-from">Unavailable From</CFormLabel>
              <CDatePicker
                date={dateFrom}
                locale="en-US"
                format={'dd/MM/yyyy'}
                placeholder="Date From"
                inputReadOnly
                className={!dateFrom && touched ? 'is-invalid' : ''}
                onDateChange={(e) => setDateFrom(e ? moment(e).format('YYYY-MM-DD') : '')}
              />
              {!dateFrom && touched && <CFormFeedback invalid>Required</CFormFeedback>}
            </CCol>
            <CCol md={6}>
              <CFormLabel htmlFor="unavailable-till">Unavailable Until</CFormLabel>
              <CDatePicker
                date={dateTill}
                locale="en-US"
                format={'dd/MM/yyyy'}
                placeholder="Date Until"
                inputReadOnly
                className={!dateTill && touched ? 'is-invalid' : ''}
                onDateChange={(e) => setDateTill(e ? moment(e).format('YYYY-MM-DD') : '')}
              />
              {!dateTill && touched && <CFormFeedback invalid>Required</CFormFeedback>}
            </CCol>
            <CCol md={12}>
              <CFormLabel htmlFor="reason">Reason</CFormLabel>
              <CFormInput
                id="reason"
                placeholder="Reason"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              />
            </CCol>
          </CRow>
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" variant="outline" onClick={handleClose}>
            Cancel
          </CButton>
          <CLoadingButton type="submit" color="primary" loading={loader}>
            Update {playerIds.length} Player{playerIds.length !== 1 ? 's' : ''}
          </CLoadingButton>
        </CModalFooter>
      </CForm>
    </CModal>
  )
}

export default SetAvailabilityModal
